import React, { memo } from "react";
import { Dropdown } from "../../dropdown/dropdown";
import { GolContactGenderDropdown } from "./gol-contact-form-interfaces";

const GolContactGenderSelection = memo((props: GolContactGenderDropdown) => {
  const onItemClick = (event: React.ChangeEvent<{ value: any }>) => {
    props.onChange({ target: { name: props.name, value: event } });
  };
  return (
    <Dropdown
      size="small"
      dataTest="dropdownGender"
      options={props.options}
      placeholderSelectable={false}
      onItemClick={onItemClick}
      label={props.label}
    />
  );
});

export { GolContactGenderSelection };
